import {createContext} from 'react';
import { useState, useEffect } from 'react';

export const UsuarioContext = createContext();

export const UsuarioProvider = ({ children }) => {
    const [usuario, setUsuario] = useState(() => {
      const stored = sessionStorage.getItem('usuario');
      return stored ? JSON.parse(stored) : null;
    });
  
    useEffect(() => {
      if (usuario !== null) {
        sessionStorage.setItem('usuario', JSON.stringify(usuario));
      } else {
        sessionStorage.removeItem('usuario'); // Limpa caso deslogue
      }
    }, [usuario]);
  
    return (
      <UsuarioContext.Provider value={{ usuario, setUsuario }}>
        {children}
      </UsuarioContext.Provider>
    );
  };